import {DISTRIBUTION_CONSTANTS, NODE_LICENSES} from '../../../constants/distribution.constants';
import Model from '../Model';
import ArtifactoryLicenseModel from './ArtifactoryLicenseModel';

export default class DistributionSiteModel extends Model {
	constructor(data) {
		super(data);
		this.name = data.name;
		this.site_name = data.site_name;
		this.city = data.city;
		this.license = new ArtifactoryLicenseModel(data)
		this.valid_edge_node = this.license.valid_license
	}

	build() {
		return {
			site_name: this.name
		};
	}
}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/DistributionSiteModel.js